import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";

import ic_delete from "../assets/images/ic_delete.svg";
import ic_edit from "../assets/images/ic_edit.svg";
import ic_eyes from "../assets/images/ic_eyes.svg";
import Modal from "react-bootstrap/Modal";
import { ToastMsg } from "./TostMsg";
import ApiConfig, { FILE_BASE_URL } from "../api/ApiConfig";
import {
  DeleteCallWithErrorResponse,
  multipartPostCallWithErrorResponse,
  PostCallWithAuthTokenWithErrorResponse,
  putMultipartWithAuthCallWithErrorResponse,
  simpleGetCallWithErrorResponse,
} from "../api/ApiServices";
import { MDBRow, MDBCol } from "mdb-react-ui-kit";
import { Pagination } from "./Pagination";
import FormLoader from "./FormLoader";

const Masaail = ({ key }) => {
  let module_id;
  let course_yr_id;
  let category_id;

  if (typeof window !== undefined) {
    module_id = localStorage.getItem("module_id");
    course_yr_id = localStorage.getItem("course_yr_id");
    category_id = localStorage.getItem("category_id");
  }

  const [AddNewGroup, setAddNewGroup] = useState(0);
  const [idEdit, setIdEdit] = useState("");
  const { sidebar, adminData } = useContext(AppContext);
  const [loader, setLoader] = useState(true);
  const [viewDetails, setViewDetails] = useState({});
  const [imageWidth, setImageWidth] = useState({
    sabaqAudio: "100%",
    Uploade: "100%",
    Uploade1: "100%",
    Tarjama: "100%",
    Description: "100%",
    subSabaqTitle: "100%",
  });
  const [addNamaz, setAddNamaz] = useState({
    sabaqName: "",
    sabaqEnglish:"",
    sabaqHindi:"",
    sabaqUrdu:"",
    sabaqArabic:"",
    sabaqDesc: "",
    sabaqDescEnglish:"",
    sabaqDescHindi:"",
    sabaqDescUrdu:"",
    sabaqDescArabic:"",
    sabaqDescAudio: "",
    sabaqDescAudioEnglish:"",
    sabaqDescAudioArabic:"",
    sabaqIcon: [],
    sabaqNameAudio: "",
    sabaqNameAudioEnglish:"",
    sabaqNameAudioArabic:"",
    sabaqDescReference: "",
    sabaqDescReferenceEnglish:"",
    sabaqDescReferenceHindi:"",
    sabaqDescReferenceUrdu:"",
    sabaqDescReferenceArabic:"",
    sabaqTeacherAudio: '',
    sabaqNameTeacherAudioEnglish:'',
    sabaqNameTeacherAudioArabic:'',
    sabaqTeacherDesc: "",
    sabaqDescTeacherAudioEnglish:"",
    sabaqDescTeacherAudioArabic:"",
    // sabaqImage: "",
    subSabaq: [
      {
        subSabaqTitle: "",
        subSabaqTitleEnglish:"",
        subSabaqTitleHindi:"",
        subSabaqTitleUrdu:"",
        subSabaqTitleArabic:"",
        subSabaqTitleAudio: "",
        subSabaqTitleAudioEnglish:"",
        subSabaqTitleAudioArabic:"",
        subSabaqDesc: "",
        subSabaqDescEnglish:"",
        subSabaqDescHindi:"",
        subSabaqDescUrdu:"",
        subSabaqDescArabic:"",
        subSabaqDescAudio: "",
        subSabaqDescAudioEnglish:"",
        subSabaqDescAudioArabic:"",
        subSabaqDescReference: "",
        subSabaqDescReferenceEnglsih:"",
        subSabaqDescReferenceHindi:"",
        subSabaqDescReferenceUrdu:"",
        subSabaqDescReferenceArabic:"",
        // teacherTarjamaAudioPath:"",
        titleTeacherAudioPath: "",
        subSabaqTitleTeacherAudioEnglish:"",
        subSabaqTitleTeacherAudioArabic:"",
        teacherDescAudioPath: "",
        subSabaqDescTeacherAudioEnglish:"",
        subSabaqDescTeacherAudioArabic:"",
      },
    ],
  });
  console.log("subsabaqREFRENCE>>",addNamaz.subSabaq)
  // const pagination = () => {
  //   $(document).ready(function () {
  //     let table;
  //     if ($.fn.dataTable.isDataTable("#table_id")) {
  //       table = $("#table_id").DataTable();
  //     } else {
  //       table = $("#table_id").DataTable({
  //         ordering: false,

  //         language: {
  //           search: "",
  //           searchPlaceholder: "Search...",
  //           sLengthMenu: "Entries per page _MENU_",
  //         },
  //       });
  //     }
  //   });
  // };
  const [add, setAdd] = useState(false);
  const handleAddClose = () => {
    setIdEdit("");
    setAddNamaz({
      sabaqName: "",
      sabaqEnglish:"",
      sabaqHindi:"",
      sabaqUrdu:"",
      sabaqArabic:"",
      sabaqDesc: "",
      sabaqDescEnglish:"",
      sabaqDescHindi:"",
      sabaqDescUrdu:"",
      sabaqDescArabic:"",
      sabaqDescAudio: "",
      sabaqDescAudioEnglish:"",
      sabaqDescAudioArabic:"",
      sabaqNameAudio: "",
      sabaqNameAudioEnglish:"",
      sabaqNameAudioArabic:"",
      sabaqIcon: [],
      // sabaqDescReference: "",
      // sabaqImage: "",
      sabaqTeacherAudio: '',
      sabaqNameTeacherAudioEnglish:'',
      sabaqNameTeacherAudioArabic:'',
      sabaqTeacherDesc: "",
      sabaqDescTeacherAudioEnglish:"",
      sabaqDescTeacherAudioArabic:"",
      subSabaq: [
        {
          subSabaqTitle: "",
          subSabaqTitleEnglish:"",
          subSabaqTitleHindi:"",
          subSabaqTitleUrdu:"",
          subSabaqTitleArabic:"",
          subSabaqTitleAudio: "",
          subSabaqTitleAudioEnglish:"",
          subSabaqTitleAudioArabic:"",
          subSabaqDesc: "",
          subSabaqDescEnglish:"",
          subSabaqDescHindi:"",
          subSabaqDescUrdu:"",
          subSabaqDescArabic:"",
          subSabaqDescAudio: "",
          subSabaqDescAudioEnglish:"",
          subSabaqDescAudioArabic:"",
          subSabaqDescReference: "",
          subSabaqDescReferenceEnglsih:"",
          subSabaqDescReferenceHindi:"",
          subSabaqDescReferenceUrdu:"",
          subSabaqDescReferenceArabic:"",
          // teacherTarjamaAudioPath:"",
          titleTeacherAudioPath: "",
          subSabaqTitleTeacherAudioEnglish:"",
          subSabaqTitleTeacherAudioArabic:"",
          teacherDescAudioPath: "",
          subSabaqDescTeacherAudioEnglish:"",
          subSabaqDescTeacherAudioArabic:"",
        },
      ],
    });
    setAdd(false);
  };
  const handleAddShow = () => setAdd(true);
  const [lasatSabaqId, setLsatSabaq] = useState("");
  const [saveBotton, setSaveBotton] = useState(false);

  const [deleteId, setDeleteId] = useState("");
  const [deleteModal, setDelete] = useState(false);
  const handleDeleteClose = () => setDelete(false);
  const handleDeleteShow = () => setDelete(true);

  const [viewModal, setView] = useState(false);
  const handleViewClose = () => setView(false);
  const handleViewShow = () => setView(true);

  const [validated, setValidated] = useState(false);
  const [masaiList, setMasaiList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const startIndex = currentPage * 15;
  const endIndex = startIndex + 15;
  const changePage = ({ selected }) => {
    setCurrentPage(selected);
  };
  const pageCount = Math.ceil(masaiList?.length / 15);
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      addSabaqApi();
    }

    setValidated(true);
  };

  //add
  const addSabaqApi = () => {
    setLoader(true);
    // handleAddClose();
    const body = {
      moduleId: module_id,
      courseYrId: (module_id === 1 || module_id === 2) && course_yr_id,
      categoryId: 8,
      userId: Number(adminData.user_id),
      sabaqNo: lasatSabaqId + 1,
      sabaqName: addNamaz.sabaqName ? addNamaz.sabaqName : "",
      sabaqEnglish: addNamaz.sabaqEnglish ? addNamaz.sabaqEnglish : "",
      sabaqHindi: addNamaz.sabaqHindi ? addNamaz.sabaqHindi : "",
      sabaqUrdu: addNamaz.sabaqUrdu ? addNamaz.sabaqUrdu : "",
      sabaqArabic: addNamaz.sabaqArabic ? addNamaz.sabaqArabic : "",
      sabaqDesc: addNamaz.sabaqDesc ? addNamaz.sabaqDesc : "",
      sabaqDescEnglish: addNamaz.sabaqDescEnglish ? addNamaz.sabaqDescEnglish : "",
      sabaqDescHindi: addNamaz.sabaqDescHindi ? addNamaz.sabaqDescHindi : "",
      sabaqDescUrdu: addNamaz.sabaqDescUrdu ? addNamaz.sabaqDescUrdu : "",
      sabaqDescArabic: addNamaz.sabaqDescArabic ? addNamaz.sabaqDescArabic : "",
      sabaqIcon: addNamaz.sabaqIcon,
      sabaqDescReference: addNamaz.sabaqDescReference
        ? addNamaz.sabaqDescReference
        : "",
      sabaqDescReferenceEnglish: addNamaz.sabaqDescReferenceEnglish
        ? addNamaz.sabaqDescReferenceEnglish
        : "",
      sabaqDescReferenceHindi: addNamaz.sabaqDescReferenceHindi
        ? addNamaz.sabaqDescReferenceHindi
        : "",
      sabaqDescReferenceUrdu: addNamaz.sabaqDescReferenceUrdu
        ? addNamaz.sabaqDescReferenceUrdu
        : "",
      sabaqDescReferenceArabic: addNamaz.sabaqDescReferenceArabic
        ? addNamaz.sabaqDescReferenceArabic
        : "",        
      sabaqId: addNamaz.SabaqId,
    };
    //all dataa paylodade
    let payLoadFormData = new FormData();
    payLoadFormData.append("moduleId", body.moduleId);
    payLoadFormData.append("courseYrId", course_yr_id);
    payLoadFormData.append("categoryId", body.categoryId);
    payLoadFormData.append("userId", body.userId);
    payLoadFormData.append("sabaqIcon", body.sabaqIcon ? body.sabaqIcon : "");
    // payLoadFormData.append("sabaqId", body.sabaqId);
    payLoadFormData.append("sabaqName", body.sabaqName);
    payLoadFormData.append("sabaqEnglish", body.sabaqEnglish);
    payLoadFormData.append("sabaqHindi", body.sabaqHindi);
    payLoadFormData.append("sabaqUrdu", body.sabaqUrdu);
    payLoadFormData.append("sabaqArabic", body.sabaqArabic);
    payLoadFormData.append("sabaqDesc", body.sabaqDesc);
    payLoadFormData.append("sabaqDescEnglish", body.sabaqDescEnglish);
    payLoadFormData.append("sabaqDescHindi", body.sabaqDescHindi);
    payLoadFormData.append("sabaqDescUrdu", body.sabaqDescUrdu);
    payLoadFormData.append("sabaqDescArabic", body.sabaqDescArabic);
    payLoadFormData.append("sabaqDescReference", body.sabaqDescReference);
    payLoadFormData.append("sabaqDescReferenceEnglish", body.sabaqDescReferenceEnglish);
    payLoadFormData.append("sabaqDescReferenceHindi", body.sabaqDescReferenceHindi);
    payLoadFormData.append("sabaqDescReferenceUrdu", body.sabaqDescReferenceUrdu);
    payLoadFormData.append("sabaqDescReferenceArabic", body.sabaqDescReferenceArabic);



    let subSabaq = addNamaz.subSabaq.map((ele, index) => {
      return {
        subSabaqDescReference: ele.subSabaqDescReference
          ? ele.subSabaqDescReference
          : "",
         subSabaqDescReferenceEnglsih: ele.subSabaqDescReferenceEnglsih
          ? ele.subSabaqDescReferenceEnglsih
          : "",
          subSabaqDescReferenceHindi: ele.subSabaqDescReferenceHindi
          ? ele.subSabaqDescReferenceHindi
          : "",
           subSabaqDescReferenceUrdu: ele.subSabaqDescReferenceUrdu
          ? ele.subSabaqDescReferenceUrdu
          : "",
           subSabaqDescReferenceArabic: ele.subSabaqDescReferenceArabic
          ? ele.subSabaqDescReferenceArabic
          : "",   
        subSabaqDesc: ele.subSabaqDesc ? ele.subSabaqDesc : "",
        subSabaqDescEnglish: ele.subSabaqDescEnglish ? ele.subSabaqDescEnglish : "",
        subSabaqDescHindi: ele.subSabaqDescHindi ? ele.subSabaqDescHindi : "",
        subSabaqDescUrdu: ele.subSabaqDescUrdu ? ele.subSabaqDescUrdu : "",
        subSabaqDescArabic: ele.subSabaqDescArabic ? ele.subSabaqDescArabic : "",
        subSabaqNo: index + 1,
        subSabaqTitle: ele.subSabaqTitle ? ele.subSabaqTitle : "",
        subSabaqTitleEnglish: ele.subSabaqTitleEnglish ? ele.subSabaqTitleEnglish : "",
        subSabaqTitleHindi: ele.subSabaqTitleHindi ? ele.subSabaqTitleHindi : "",
        subSabaqTitleUrdu: ele.subSabaqTitleUrdu ? ele.subSabaqTitleUrdu : "",
        subSabaqTitleArabic: ele.subSabaqTitleArabic ? ele.subSabaqTitleArabic : "",
        subSabaqDescAudio:
          ele.subSabaqDescAudio == "" ? "no file" : "file name",
         subSabaqDescAudioEnglish:
          ele.subSabaqDescAudioEnglish == "" ? "no file" : "file name",
         subSabaqDescAudioArabic:
          ele.subSabaqDescAudioArabic == "" ? "no file" : "file name",    
          subSabaqTitleAudio:
          ele.subSabaqTitleAudio == "" ? "no file" : "file name",
           subSabaqTitleAudioEnglish:
          ele.subSabaqTitleAudioEnglish == "" ? "no file" : "file name",
           subSabaqTitleAudioArabic:
          ele.subSabaqTitleAudioArabic == "" ? "no file" : "file name",
          subSabaqTitleTeacherAudio:
          ele.titleTeacherAudioPath == "" ? "no file" : "file name",
           subSabaqTitleTeacherAudioEnglish:
          ele.subSabaqTitleTeacherAudioEnglish == "" ? "no file" : "file name",
           subSabaqTitleTeacherAudioArabic:
          ele.subSabaqTitleTeacherAudioArabic == "" ? "no file" : "file name",
        subSabaqDescTeacherAudio:
          ele.teacherDescAudioPath == "" ? "no file" : "file name",
          subSabaqDescTeacherAudioEnglish:
          ele.subSabaqDescTeacherAudioEnglish == "" ? "no file" : "file name",
          subSabaqDescTeacherAudioArabic:
          ele.subSabaqDescTeacherAudioArabic == "" ? "no file" : "file name",    
        // subSabaqTarjamaTeacherAudio:
        // ele.teacherTarjamaAudioPath == "" ? "no file" : "file name",
        // subSabaqTarjamaAudio: ele.tarjamaAudioPath=="" ?"no file":"file name",
      };
    });

    let subSabaqEdit = addNamaz.subSabaq.map((ele, index) => {
      return {
        subSabaqDescReference: ele.subSabaqDescReference
          ? ele.subSabaqDescReference
          : "",
         subSabaqDescReferenceEnglsih: ele.subSabaqDescReferenceEnglsih
          ? ele.subSabaqDescReferenceEnglsih
          : "",
         subSabaqDescReferenceHindi: ele.subSabaqDescReferenceHindi
          ? ele.subSabaqDescReferenceHindi
          : "",
          subSabaqDescReferenceUrdu: ele.subSabaqDescReferenceUrdu
          ? ele.subSabaqDescReferenceUrdu
          : "",
           subSabaqDescReferenceArabic: ele.subSabaqDescReferenceArabic
          ? ele.subSabaqDescReferenceArabic
          : "",     
        subSabaqDesc: ele.subSabaqDesc ? ele.subSabaqDesc : "",
        subSabaqDescEnglish: ele.subSabaqDescEnglish ? ele.subSabaqDescEnglish : "",
        subSabaqDescHindi: ele.subSabaqDescHindi ? ele.subSabaqDescHindi : "",
        subSabaqDescUrdu: ele.subSabaqDescUrdu ? ele.subSabaqDescUrdu : "",
        subSabaqDescArabic: ele.subSabaqDescArabic ? ele.subSabaqDescArabic : "",
        subSabaqId: ele.subSabaqId,
        subSabaqNo: index + 1,

        subSabaqTitle: ele.subSabaqTitle ? ele.subSabaqTitle : "",
        subSabaqTitleEnglish: ele.subSabaqTitleEnglish ? ele.subSabaqTitleEnglish : "",
        subSabaqTitleHindi: ele.subSabaqTitleHindi ? ele.subSabaqTitleHindi : "",
        subSabaqTitleUrdu: ele.subSabaqTitleUrdu ? ele.subSabaqTitleUrdu : "",
        subSabaqTitleArabic: ele.subSabaqTitleArabic ? ele.subSabaqTitleArabic : "",
        subSabaqDescAudio:
          typeof ele.subSabaqDescAudio == "object" ? "updated" : "not updated",
         subSabaqDescAudioEnglish:
          typeof ele.subSabaqDescAudioEnglish == "object" ? "updated" : "not updated",
          subSabaqDescAudioArabic:
          typeof ele.subSabaqDescAudioArabic == "object" ? "updated" : "not updated",   
        subSabaqTitleAudio:
          typeof ele.titleAudioPath == "object" ? "updated" : "not updated",
         subSabaqTitleAudioEnglish:
          typeof ele.subSabaqTitleAudioEnglish == "object" ? "updated" : "not updated",
         subSabaqTitleAudioArabic:
          typeof ele.subSabaqTitleAudioArabic == "object" ? "updated" : "not updated",    
        subSabaqTitleTeacherAudio:
          typeof ele.titleTeacherAudioPath == "object" ? "updated" : "not updated",
            subSabaqTitleTeacherAudioEnglish:
          typeof ele.subSabaqTitleTeacherAudioEnglish == "object" ? "updated" : "not updated",
            subSabaqTitleTeacherAudioArabic:
          typeof ele.subSabaqTitleTeacherAudioArabic == "object" ? "updated" : "not updated",
        subSabaqDescTeacherAudio:
          typeof ele.teacherDescAudioPath == "object" ? "updated" : "not updated",
         subSabaqDescTeacherAudioEnglish:
          typeof ele.subSabaqDescTeacherAudioEnglish == "object" ? "updated" : "not updated",
         subSabaqDescTeacherAudioArabic:
          typeof ele.subSabaqDescTeacherAudioArabic == "object" ? "updated" : "not updated",    
        // subSabaqTarjamaTeacherAudio:
        // typeof ele.teacherTarjamaAudioPath == "object" ? "updated" : "not updated"
      };
    });
    idEdit === "edit"
      ? payLoadFormData.append("subSabaq", JSON.stringify(subSabaqEdit))
      : payLoadFormData.append("subSabaq", JSON.stringify(subSabaq));

    idEdit === "edit"
      ? payLoadFormData.append("sabaqId", body.sabaqId)
      : payLoadFormData.append("sabaqNo", body.sabaqNo);

    let newSubaqAudio = [];
    newSubaqAudio.push(addNamaz.sabaqNameAudio);
    newSubaqAudio.map((ele) =>
      payLoadFormData.append("sabaqNameAudio", ele ? ele : "")
    );

     let sabaqNameAudioEnglish = [];
    sabaqNameAudioEnglish.push(addNamaz.sabaqNameAudioEnglish);
    sabaqNameAudioEnglish.map((ele) =>
      payLoadFormData.append("sabaqNameAudioEnglish", ele ? ele : "")
    );

     let sabaqNameAudioArabic = [];
    sabaqNameAudioArabic.push(addNamaz.sabaqNameAudioArabic);
    sabaqNameAudioArabic.map((ele) =>
      payLoadFormData.append("sabaqNameAudioArabic", ele ? ele : "")
    );

    let newSubaqTeacherAudio = [];
    newSubaqTeacherAudio.push(addNamaz.sabaqTeacherAudio);
    newSubaqTeacherAudio.map((ele) =>
      payLoadFormData.append("sabaqNameTeacherAudio", ele ? ele : "")
    );

    let sabaqNameTeacherAudioEnglish = [];
    sabaqNameTeacherAudioEnglish.push(addNamaz.sabaqNameTeacherAudioEnglish);
    sabaqNameTeacherAudioEnglish.map((ele) =>
      payLoadFormData.append("sabaqNameTeacherAudioEnglish", ele ? ele : "")
    );

    let sabaqNameTeacherAudioArabic = [];
    sabaqNameTeacherAudioArabic.push(addNamaz.sabaqNameTeacherAudioArabic);
    sabaqNameTeacherAudioArabic.map((ele) =>
      payLoadFormData.append("sabaqNameTeacherAudioArabic", ele ? ele : "")
    );

    let newSubaqTeacherDescAudio = [];
    newSubaqTeacherDescAudio.push(addNamaz.sabaqTeacherDesc);
    newSubaqTeacherDescAudio.map((ele) =>
      payLoadFormData.append("sabaqDescTeacherAudio", ele ? ele : "")
    );

    let sabaqDescTeacherAudioEnglish = [];
    sabaqDescTeacherAudioEnglish.push(addNamaz.sabaqDescTeacherAudioEnglish);
    sabaqDescTeacherAudioEnglish.map((ele) =>
      payLoadFormData.append("sabaqDescTeacherAudioEnglish", ele ? ele : "")
    );

    let sabaqDescTeacherAudioArabic = [];
    sabaqDescTeacherAudioArabic.push(addNamaz.sabaqDescTeacherAudioArabic);
    sabaqDescTeacherAudioArabic.map((ele) =>
      payLoadFormData.append("sabaqDescTeacherAudioArabic", ele ? ele : "")
    );

    let newImage = [];
    newImage.push(addNamaz.sabaqImage);
    newImage.map((ele) => payLoadFormData.append("sabaqImage", ele ? ele : ""));

    let newImage2 = [];
    newImage2.push(addNamaz.sabaqDescAudio);
    newImage2.map((ele) => payLoadFormData.append("sabaqDescAudio", ele ? ele : ""));

    let sabaqDescAudioEnglish = [];
    sabaqDescAudioEnglish.push(addNamaz.sabaqDescAudioEnglish);
    sabaqDescAudioEnglish.map((ele) => payLoadFormData.append("sabaqDescAudioEnglish", ele ? ele : ""));

    let sabaqDescAudioArabic = [];
    sabaqDescAudioArabic.push(addNamaz.sabaqDescAudioArabic);
    sabaqDescAudioArabic.map((ele) => payLoadFormData.append("sabaqDescAudioArabic", ele ? ele : ""));

    addNamaz.subSabaq.map((ele) => payLoadFormData.append("subSabaqDescAudio", ele.subSabaqDescAudio ? ele.subSabaqDescAudio : ""));
    addNamaz.subSabaq.map((ele) => payLoadFormData.append("subSabaqDescAudioEnglish", ele.subSabaqDescAudioEnglish ? ele.subSabaqDescAudioEnglish : ""));
    addNamaz.subSabaq.map((ele) => payLoadFormData.append("subSabaqDescAudioArabic", ele.subSabaqDescAudioArabic ? ele.subSabaqDescAudioArabic : ""));
    addNamaz.subSabaq.map((ele) => payLoadFormData.append("subSabaqTitleAudio", ele.subSabaqTitleAudio ? ele.subSabaqTitleAudio : ""));
    addNamaz.subSabaq.map((ele) => payLoadFormData.append("subSabaqTitleAudioEnglish", ele.subSabaqTitleAudioEnglish ? ele.subSabaqTitleAudioEnglish : ""));
    addNamaz.subSabaq.map((ele) => payLoadFormData.append("subSabaqTitleAudioArabic", ele.subSabaqTitleAudioArabic ? ele.subSabaqTitleAudioArabic : ""));
    addNamaz.subSabaq.map((ele) => payLoadFormData.append("subSabaqTitleTeacherAudio", ele.titleTeacherAudioPath ? ele.titleTeacherAudioPath : "")
    );
      addNamaz.subSabaq.map((ele) => payLoadFormData.append("subSabaqTitleTeacherAudioEnglish", ele.subSabaqTitleTeacherAudioEnglish ? ele.subSabaqTitleTeacherAudioEnglish : "")
    );
      addNamaz.subSabaq.map((ele) => payLoadFormData.append("subSabaqTitleTeacherAudioArabic", ele.subSabaqTitleTeacherAudioArabic ? ele.subSabaqTitleTeacherAudioArabic : "")
    );
    addNamaz.subSabaq.map((ele) => payLoadFormData.append("subSabaqDescTeacherAudio", ele.teacherDescAudioPath ? ele.teacherDescAudioPath : ""));
    addNamaz.subSabaq.map((ele) => payLoadFormData.append("subSabaqDescTeacherAudioEnglish", ele.subSabaqDescTeacherAudioEnglish ? ele.subSabaqDescTeacherAudioEnglish : ""));
    addNamaz.subSabaq.map((ele) => payLoadFormData.append("subSabaqDescTeacherAudioArabic", ele.subSabaqDescTeacherAudioArabic ? ele.subSabaqDescTeacherAudioArabic : ""));

    // addNamaz.subSabaq.map((ele) =>
    //   payLoadFormData.append(
    //     "subSabaqTarjamaTeacherAudio",
    //     ele.teacherTarjamaAudioPath ? ele.teacherTarjamaAudioPath : ""
    //   )
    // );


    setLoader(true);
    idEdit === "edit"
      ? putMultipartWithAuthCallWithErrorResponse(
        ApiConfig.UPDATE_SABAQ_SECTION,
        payLoadFormData
      )
        .then((res) => {
          setLoader(false);

          if (res.json && res.json?.success === true) {
            handleAddClose();
            masaiListApi();
            setSaveBotton(false);

            ToastMsg("success", res.json.message);
          } else {
            ToastMsg("error", res.json.message);
          }
        })
        .catch((err) => {
          setLoader(false);

          ToastMsg("error", "something went wrong");
        })
      : multipartPostCallWithErrorResponse(
        ApiConfig.ADD_SABAQ_SECTION,
        payLoadFormData
        // payLoadFormDataNew
      )
        .then((res) => {
          setLoader(false);

          if (res.json && res.json?.success === true) {
            handleAddClose();
            masaiListApi();
            setSaveBotton(false);

            ToastMsg("success", res.json.message);
          } else {
            ToastMsg("error", res.json.message);
          }
        })
        .catch((err) => {
          setLoader(false);

          ToastMsg("error", "something went wrong");
        });
  };
  useEffect(() => {
    masaiListApi();
  }, [key]);
  //
  const masaiListApi = () => {
    const apiUrl = (module_id == 1 || module_id == 2)
      ? ApiConfig.GET_ALL_SABAQ + `moduleId=${module_id}&courseYrId=${course_yr_id}&categoryId=${8}`
      : ApiConfig.GET_ALL_SABAQ + `moduleId=${module_id}&categoryId=${8}`;
    // setIsLoading(true);

    simpleGetCallWithErrorResponse(apiUrl
      // ApiConfig.GET_ALL_SABAQ +
      //   `moduleId=${module_id}&categoryId=${category_id || 6}`
    )
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
          setMasaiList(res.json?.data?.allSabaq);
          setLsatSabaq(res.json?.data.allSabaq.length);
        } else {
          // ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };

  const MasaiLisDeleteApi = () => {
    setLoader(true);
    const body = {
      categoryId: 8,

      sabaqId: deleteId,
    };
    // setIsLoading(true);
    DeleteCallWithErrorResponse(
      ApiConfig.DELETE_SABAQ_SECION,

      JSON.stringify({
        ...body,
      })
    )
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
          masaiListApi();
          handleDeleteClose();
          ToastMsg("success", res.json.message);
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };
  //
  const EditListApi = (id, param) => {
    simpleGetCallWithErrorResponse(
      ApiConfig.VIEW_SABAQ_SECTION + `sabaqId=${id}&categoryId=${category_id}`
    )
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
          let data = res.json?.data;
          setAddNamaz({
            SabaqId: data?.SabaqId,
            sabaqName: data?.sabaqName ? data?.sabaqName : "",
            sabaqEnglish: data?.sabaqEnglish ? data?.sabaqEnglish : "",
            sabaqHindi: data?.sabaqHindi ? data?.sabaqHindi : "",
            sabaqUrdu: data?.sabaqUrdu ? data?.sabaqUrdu : "",
            sabaqArabic: data?.sabaqArabic ? data?.sabaqArabic : "",
            sabaqDesc: data?.sabaqDesc ? data?.sabaqDesc : "",
            sabaqDescEnglish: data?.sabaqDescEnglish ? data?.sabaqDescEnglish : "",
            sabaqDescHindi: data?.sabaqDescHindi ? data?.sabaqDescHindi : "",
            sabaqDescUrdu: data?.sabaqDescUrdu ? data?.sabaqDescUrdu : "",
            sabaqDescArabic: data?.sabaqDescArabic ? data?.sabaqDescArabic : "",
            sabaqDescAudio: data?.sabaqDescAudio ? data?.sabaqDescAudio : "",
            sabaqDescAudioEnglish: data?.sabaqDescAudioEnglish ? data?.sabaqDescAudioEnglish : "",
            sabaqDescAudioArabic: data?.sabaqDescAudioArabic ? data?.sabaqDescAudioArabic : "",
            sabaqNameAudio: data?.sabaqAudio ? data?.sabaqAudio : "",
            sabaqNameAudioEnglish: data?.sabaqNameAudioEnglish ? data?.sabaqNameAudioEnglish : "",
            sabaqNameAudioArabic: data?.sabaqNameAudioArabic ? data?.sabaqNameAudioArabic : "",
            sabaqIcon: data?.sabaqIcon,
            sabaqImage: data?.sabaqImage ? data?.sabaqImage : "",
            sabaqDescReference: data?.sabaqDescReference
              ? data?.sabaqDescReference
              : "",
             sabaqDescReferenceEnglish: data?.sabaqDescReferenceEnglish
              ? data?.sabaqDescReferenceEnglish
              : "",
             sabaqDescReferenceHindi: data?.sabaqDescReferenceHindi
              ? data?.sabaqDescReferenceHindi
              : "",
              sabaqDescReferenceUrdu: data?.sabaqDescReferenceUrdu
              ? data?.sabaqDescReferenceUrdu
              : "",
               sabaqDescReferenceArabic: data?.sabaqDescReferenceArabic
              ? data?.sabaqDescReferenceArabic
              : "",     
            sabaqTeacherAudio: data?.sabaqTeacherAudio
              ? data?.sabaqTeacherAudio
              : "",
             sabaqNameTeacherAudioEnglish: data?.sabaqNameTeacherAudioEnglish
              ? data?.sabaqNameTeacherAudioEnglish
              : "",
             sabaqNameTeacherAudioArabic: data?.sabaqNameTeacherAudioArabic
              ? data?.sabaqNameTeacherAudioArabic
              : "",    
            sabaqTeacherDesc: data?.sabaqTeacherDesc
              ? data?.sabaqTeacherDesc
              : "",
            sabaqDescTeacherAudioEnglish: data?.sabaqDescTeacherAudioEnglish
              ? data?.sabaqDescTeacherAudioEnglish
              : "",
            sabaqDescTeacherAudioArabic: data?.sabaqDescTeacherAudioArabic
              ? data?.sabaqDescTeacherAudioArabic
              : "",
            subSabaq:
              data &&
              data.subSabaqs.map((ele, index) => {
                return {
                  subSabaqTitle: ele.subSabaqTitle ? ele.subSabaqTitle : "",
                  subSabaqTitleEnglish: ele.subSabaqTitleEnglish ? ele.subSabaqTitleEnglish : "",
                  subSabaqTitleHindi: ele.subSabaqTitleHindi ? ele.subSabaqTitleHindi : "",
                  subSabaqTitleUrdu: ele.subSabaqTitleUrdu ? ele.subSabaqTitleUrdu : "",
                  subSabaqTitleArabic: ele.subSabaqTitleArabic ? ele.subSabaqTitleArabic : "",
                  subSabaqDesc: ele.subSabaqDesc ? ele.subSabaqDesc : "",
                  subSabaqDescEnglish: ele.subSabaqDescEnglish ? ele.subSabaqDescEnglish : "",
                  subSabaqDescHindi: ele.subSabaqDescHindi ? ele.subSabaqDescHindi : "",
                  subSabaqDescUrdu: ele.subSabaqDescUrdu ? ele.subSabaqDescUrdu : "",
                  subSabaqDescArabic: ele.subSabaqDescArabic ? ele.subSabaqDescArabic : "",
                  subSabaqDescReference: ele.subSabaqDescReference ? ele.subSabaqDescReference : "",
                  subSabaqDescReferenceEnglsih: ele.subSabaqDescReferenceEnglsih ? ele.subSabaqDescReferenceEnglsih : "",
                  subSabaqDescReferenceHindi: ele.subSabaqDescReferenceHindi ? ele.subSabaqDescReferenceHindi : "",
                  subSabaqDescReferenceUrdu: ele.subSabaqDescReferenceUrdu ? ele.subSabaqDescReferenceUrdu : "",
                  subSabaqDescReferenceArabic: ele.subSabaqDescReferenceArabic ? ele.subSabaqDescReferenceArabic : "",
                  subSabaqDescAudio: ele.descAudioPath
                    ? ele.descAudioPath
                    : ":",
                  subSabaqDescAudioEnglish: ele.subSabaqDescAudioEnglish
                    ? ele.subSabaqDescAudioEnglish
                    : ":",
                  subSabaqDescAudioArabic: ele.subSabaqDescAudioArabic
                    ? ele.subSabaqDescAudioArabic
                    : ":",    
                  subSabaqTitleAudio: ele.titleAudioPath
                    ? ele.titleAudioPath
                    : "",
                  subSabaqTitleAudioEnglish: ele.subSabaqTitleAudioEnglish
                    ? ele.subSabaqTitleAudioEnglish
                    : "",
                  subSabaqTitleAudioArabic: ele.subSabaqTitleAudioArabic
                    ? ele.subSabaqTitleAudioArabic
                    : "",
                  subSabaqTarjamaAudio: ele.tarjamaAudioPath
                    ? ele.tarjamaAudioPath
                    : "",
                  subSabaqTarjama: ele.tarjama ? ele.tarjama : "",
                          
                  titleTeacherAudioPath: ele.titleTeacherAudioPath
                    ? ele.titleTeacherAudioPath
                    : "",
                   subSabaqTitleTeacherAudioEnglish: ele.subSabaqTitleTeacherAudioEnglish
                    ? ele.subSabaqTitleTeacherAudioEnglish
                    : "",
                   subSabaqTitleTeacherAudioArabic: ele.subSabaqTitleTeacherAudioArabic
                    ? ele.subSabaqTitleTeacherAudioArabic
                    : "",    
                  teacherDescAudioPath: ele.teacherDescAudioPath
                    ? ele.teacherDescAudioPath
                    : "",
                   subSabaqDescTeacherAudioEnglish: ele.subSabaqDescTeacherAudioEnglish
                    ? ele.subSabaqDescTeacherAudioEnglish
                    : "",
                    subSabaqDescTeacherAudioArabic: ele.subSabaqDescTeacherAudioArabic
                    ? ele.subSabaqDescTeacherAudioArabic
                    : "",   
                  subSabaqId: ele.subSabaqId,
                  subSabaqNo: ele.subSabaqNo ? ele.subSabaqNo : index + 1,
                };
              }),
          });

          handleAddShow();
          // ToastMsg("success", res.json.message);
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };
  //view the
  console.log("VIEW..",viewDetails);
  const viewDetailshandle = (id) => {
    simpleGetCallWithErrorResponse(
      ApiConfig.VIEW_SABAQ_SECTION + `sabaqId=${id}&categoryId=${category_id}`
    )
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
          setViewDetails(res.json.data);
          handleViewShow();
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };

  return (
    <main
      id="cx-main"
      className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
      <div className="heading-btn-main">
        <div className="heading-common">
          <label htmlFor="">Masaail</label>
        </div>
        <div className="add-btn">
          <button onClick={handleAddShow}>
            Add Sabaq
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path fill="white" d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z" />
            </svg>
          </button>
        </div>
      </div>
      {/* ======================= START ADD ========================== */}
      <Modal
        show={add}
        onHide={handleAddClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          {/* <Modal.Title>Add Masaail</Modal.Title> */}
          <Modal.Title>
            {idEdit === "edit" ? "Update  Masaail" : "Add Masaail"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated} className="fw-bold" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  value={addNamaz?.sabaqName}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqName: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>
               <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Name(English)</Form.Label>
                <Form.Control
                  required
                  type="text"
                  value={addNamaz?.sabaqEnglish}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqEnglish: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>
               <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Name(Hindi)</Form.Label>
                <Form.Control
                  required
                  type="text"
                  value={addNamaz?.sabaqHindi}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqHindi: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>
               <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Name(Urdu)</Form.Label>
                <Form.Control
                  required
                  type="text"
                  value={addNamaz?.sabaqUrdu}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqUrdu: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>
               <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Name(Arabic)</Form.Label>
                <Form.Control
                  required
                  type="text"
                  value={addNamaz?.sabaqArabic}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqArabic: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>

              {idEdit ? (
                <>
                  <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio(Teacher And Student)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqNameAudio === "string"
                          ? addNamaz?.sabaqNameAudio.substring(
                            addNamaz?.sabaqNameAudio.length - 15,
                            addNamaz?.sabaqNameAudio.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqAudio"
                        style={{ width: imageWidth.sabaqAudio }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaqAudio: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqNameAudio: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                    <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio(Teacher And Student)(English)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqNameAudioEnglish === "string"
                          ? addNamaz?.sabaqNameAudioEnglish.substring(
                            addNamaz?.sabaqNameAudioEnglish.length - 15,
                            addNamaz?.sabaqNameAudioEnglish.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqAudio"
                        style={{ width: imageWidth.sabaqAudio }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaqAudio: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqNameAudioEnglish: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                    <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio(Teacher And Student)(Arabic)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqNameAudioArabic === "string"
                          ? addNamaz?.sabaqNameAudioArabic.substring(
                            addNamaz?.sabaqNameAudioArabic.length - 15,
                            addNamaz?.sabaqNameAudioArabic.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqAudio"
                        style={{ width: imageWidth.sabaqAudio }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaqAudio: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqNameAudioArabic: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                </>
              ) : (
                <>
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio(Teacher And Student)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqAudio"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqNameAudio: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                  <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio(Teacher And Student)(English)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqAudio"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqNameAudioEnglish: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                  <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio(Teacher And Student)(Arabic)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqAudio"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqNameAudioArabic: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                </>
              )}

              {idEdit ? (
                <>
                  <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio(Teacher)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqTeacherAudio === "string"
                          ? addNamaz?.sabaqTeacherAudio.substring(
                            addNamaz?.sabaqTeacherAudio.length - 15,
                            addNamaz?.sabaqTeacherAudio.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqAudio"
                        style={{ width: imageWidth.sabaqAudio }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaqAudio: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqTeacherAudio: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                   <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio(Teacher)(English)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqNameTeacherAudioEnglish === "string"
                          ? addNamaz?.sabaqNameTeacherAudioEnglish.substring(
                            addNamaz?.sabaqNameTeacherAudioEnglish.length - 15,
                            addNamaz?.sabaqNameTeacherAudioEnglish.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqAudio"
                        style={{ width: imageWidth.sabaqAudio }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaqAudio: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqNameTeacherAudioEnglish: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                   <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio(Teacher)(Arabic)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqNameTeacherAudioArabic === "string"
                          ? addNamaz?.sabaqNameTeacherAudioArabic.substring(
                            addNamaz?.sabaqNameTeacherAudioArabic.length - 15,
                            addNamaz?.sabaqNameTeacherAudioArabic.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqAudio"
                        style={{ width: imageWidth.sabaqAudio }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaqAudio: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqNameTeacherAudioArabic: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                </>
              ) : (
                <>
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio(Teacher)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqAudio"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqTeacherAudio: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                  <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio(Teacher)(English)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqAudio"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqNameTeacherAudioEnglish: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                  <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio(Teacher)(Arabic)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqAudio"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqNameTeacherAudioArabic: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                </>
              )}
              {/*{idEdit ? (
                <div>
                  <MDBRow>
                    <MDBCol lg="1" md="1" className="mb-4">
                      <img
                        src={
                          !addNamaz?.sabaqIcon
                            ? ""
                            : ApiConfig.FILE_BASE_URL +
                              addNamaz?.sabaqIcon.length
                            ? ApiConfig.FILE_BASE_URL + addNamaz?.sabaqIcon
                            : ApiConfig.FILE_BASE_URL + addNamaz?.sabaqIcon &&
                              URL.createObjectURL(
                                ApiConfig.FILE_BASE_URL + addNamaz?.sabaqIcon
                              )
                        }
                        className="img-fluid rounded value"
                        alt=""
                      />
                    </MDBCol>
                  </MDBRow>
                  <div className="col-md-12 mb-3">
                      <Form.Label>Update Sabaq Icon</Form.Label>
                      <Form.Control
                        type="file"
                        accept="image/*"
                        name="updateSabaqIcon"
                        onChange={(e) => {
                          setAddNamaz({
                            ...addNamaz,
                            sabaqIcon: e.target.files[0],
                          });
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Icon
                      </Form.Control.Feedback>
                    </div>
                </div>
              ) : (
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Icon</Form.Label>
                  <Form.Control
                    // required
                    type="file"
                    // accept="audio/mp3,audio/*;capture=microphone"
                    accept="image/*"
                    name="sabaqAudio"
                    src={addNamaz?.sabaqIcon}
                    //  / value={addNamaz?.sabaqAudio}
                    onChange={(e) => {
                      setAddNamaz({
                        ...addNamaz,
                        sabaqIcon: e.target.files[0],
                      });
                    }}
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Icon
                  </Form.Control.Feedback>
                </div>
              )}*/}

              <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={addNamaz?.sabaqDesc}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqDesc: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Tarjama.
                </Form.Control.Feedback>
              </div>
                <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Description(English)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={addNamaz?.sabaqDescEnglish}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqDescEnglish: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Tarjama.
                </Form.Control.Feedback>
              </div>
                <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Description(Hindi)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={addNamaz?.sabaqDescHindi}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqDescHindi: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Tarjama.
                </Form.Control.Feedback>
              </div>
                <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Description(Urdu)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={addNamaz?.sabaqDescUrdu}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqDescUrdu: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Tarjama.
                </Form.Control.Feedback>
              </div>
                <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Description(Arabic)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={addNamaz?.sabaqDescArabic}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqDescArabic: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Tarjama.
                </Form.Control.Feedback>
              </div>

              {idEdit ? (
                <>
                  <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Description Audio(Teacher And Student)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqDescAudio === "string"
                          ? addNamaz?.sabaqDescAudio.substring(
                            addNamaz?.sabaqDescAudio.length - 15,
                            addNamaz?.sabaqDescAudio.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqImage"
                        style={{ width: imageWidth.Uploade }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqDescAudio: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                   <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Description Audio(Teacher And Student)(English)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqDescAudioEnglish === "string"
                          ? addNamaz?.sabaqDescAudioEnglish.substring(
                            addNamaz?.sabaqDescAudioEnglish.length - 15,
                            addNamaz?.sabaqDescAudioEnglish.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqImage"
                        style={{ width: imageWidth.Uploade }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqDescAudioEnglish: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                   <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Description Audio(Teacher And Student)(Arabic)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqDescAudioArabic === "string"
                          ? addNamaz?.sabaqDescAudioArabic.substring(
                            addNamaz?.sabaqDescAudioArabic.length - 15,
                            addNamaz?.sabaqDescAudioArabic.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqImage"
                        style={{ width: imageWidth.Uploade }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqDescAudioArabic: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                </>
              ) : (
                <>
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Description Audio(Teacher And Student)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqImage"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqDescAudio: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                 <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Description Audio(Teacher And Student)(English)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqImage"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqDescAudioEnglish: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                 <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Description Audio(Teacher And Student)(Arabic)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqImage"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqDescAudioArabic: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                </>
              )}
              {idEdit ? (
                <>
                  <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Description Audio(Teacher)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqTeacherDesc === "string"
                          ? addNamaz?.sabaqTeacherDesc.substring(
                            addNamaz?.sabaqTeacherDesc.length - 15,
                            addNamaz?.sabaqTeacherDesc.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqImage"
                        style={{ width: imageWidth.Uploade }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqTeacherDesc: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                    <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Description Audio(Teacher)(English)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqDescTeacherAudioEnglish === "string"
                          ? addNamaz?.sabaqDescTeacherAudioEnglish.substring(
                            addNamaz?.sabaqDescTeacherAudioEnglish.length - 15,
                            addNamaz?.sabaqDescTeacherAudioEnglish.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqImage"
                        style={{ width: imageWidth.Uploade }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqDescTeacherAudioEnglish: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                    <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Description Audio(Teacher)(Arabic)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqDescTeacherAudioArabic === "string"
                          ? addNamaz?.sabaqDescTeacherAudioArabic.substring(
                            addNamaz?.sabaqDescTeacherAudioArabic.length - 15,
                            addNamaz?.sabaqDescTeacherAudioArabic.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqImage"
                        style={{ width: imageWidth.Uploade }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqDescTeacherAudioArabic: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                </>
              ) : (
                <>
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Description Audio(Teacher)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqImage"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqTeacherDesc: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                 <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Description Audio(Teacher)(English)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqImage"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqDescTeacherAudioEnglish: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                 <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Description Audio(Teacher)(Arabic)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqImage"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqDescTeacherAudioArabic: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                </>
              )}
              {idEdit ? (
                <>
                  <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Image
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqImage === "string"
                          ? addNamaz?.sabaqImage.substring(
                            addNamaz?.sabaqImage.length - 15,
                            addNamaz?.sabaqImage.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        name="sabaqImage"
                        accept="image/x-png,image/gif,image/jpeg"
                        style={{ width: imageWidth.Uploade1 }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade1: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqImage: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                </>
              ) : (
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Image</Form.Label>
                  <Form.Control
                    type="file"
                    name="sabaqImage"
                    accept="image/x-png,image/gif,image/jpeg"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqImage: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
              )}

              <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Reference</Form.Label>
                <Form.Control
                  type="text"
                  value={addNamaz?.sabaqDescReference}
                  onChange={(e) =>
                    setAddNamaz({
                      ...addNamaz,
                      sabaqDescReference: e.target.value,
                    })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Reference
                </Form.Control.Feedback>
              </div>
                 <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Reference(English)</Form.Label>
                <Form.Control
                  type="text"
                  value={addNamaz?.sabaqDescReferenceEnglish}
                  onChange={(e) =>
                    setAddNamaz({
                      ...addNamaz,
                      sabaqDescReferenceEnglish: e.target.value,
                    })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Reference
                </Form.Control.Feedback>
              </div>
                <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Reference(Hindi)</Form.Label>
                <Form.Control
                  type="text"
                  value={addNamaz?.sabaqDescReferenceHindi}
                  onChange={(e) =>
                    setAddNamaz({
                      ...addNamaz,
                      sabaqDescReferenceHindi: e.target.value,
                    })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Reference
                </Form.Control.Feedback>
              </div>
                  <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Reference(Urdu)</Form.Label>
                <Form.Control
                  type="text"
                  value={addNamaz?.sabaqDescReferenceUrdu}
                  onChange={(e) =>
                    setAddNamaz({
                      ...addNamaz,
                      sabaqDescReferenceUrdu: e.target.value,
                    })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Reference
                </Form.Control.Feedback>
              </div>
                   <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Reference(Arabic)</Form.Label>
                <Form.Control
                  type="text"
                  value={addNamaz?.sabaqDescReferenceArabic}
                  onChange={(e) =>
                    setAddNamaz({
                      ...addNamaz,
                      sabaqDescReferenceArabic: e.target.value,
                    })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Reference
                </Form.Control.Feedback>
              </div>


              {addNamaz.subSabaq &&
                addNamaz.subSabaq.map((elementInArray, index) => {
                  return (
                    <div className="col-md-12 sub-group-main">
                      <div className="row">
                        <h6 className="fw-bold">Sub Sabaq Details</h6>
                        <div className="col-md-6 mb-3">
                          <Form.Label>
                            Sub Sabaq Title <span>{index + 1}</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqTitle}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqTitle: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Sabaq Name
                          </Form.Control.Feedback>
                        </div>
                          <div className="col-md-6 mb-3">
                          <Form.Label>
                            Sub Sabaq Title(English) <span>{index + 1}</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqTitleEnglish}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqTitleEnglish: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Sabaq Name
                          </Form.Control.Feedback>
                        </div>
                          <div className="col-md-6 mb-3">
                          <Form.Label>
                            Sub Sabaq Title(Hindi) <span>{index + 1}</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqTitleHindi}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqTitleHindi: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Sabaq Name
                          </Form.Control.Feedback>
                        </div>
                          <div className="col-md-6 mb-3">
                          <Form.Label>
                            Sub Sabaq Title(Urdu) <span>{index + 1}</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqTitleUrdu}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqTitleUrdu: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Sabaq Name
                          </Form.Control.Feedback>
                        </div>
                          <div className="col-md-6 mb-3">
                          <Form.Label>
                            Sub Sabaq Title(Arabic) <span>{index + 1}</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqTitleArabic}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqTitleArabic: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Sabaq Name
                          </Form.Control.Feedback>
                        </div>

                        {idEdit ? (
                          <>
                            <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Title Audio(Teacher And Student)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.subSabaqTitleAudio ===
                                    "string"
                                    ? elementInArray?.subSabaqTitleAudio.substring(
                                      elementInArray?.subSabaqTitleAudio
                                        .length - 15,
                                      elementInArray?.subSabaqTitleAudio
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.subSabaqTitle }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      subSabaqTitle: "100%",
                                    });
                                    setAddNamaz({
                                      ...addNamaz,
                                      subSabaq: addNamaz.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              subSabaqTitleAudio:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                             <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Title Audio(Teacher And Student)(English)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.subSabaqTitleAudioEnglish ===
                                    "string"
                                    ? elementInArray?.subSabaqTitleAudioEnglish.substring(
                                      elementInArray?.subSabaqTitleAudioEnglish
                                        .length - 15,
                                      elementInArray?.subSabaqTitleAudioEnglish
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.subSabaqTitle }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      subSabaqTitle: "100%",
                                    });
                                    setAddNamaz({
                                      ...addNamaz,
                                      subSabaq: addNamaz.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              subSabaqTitleAudioEnglish:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                             <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Title Audio(Teacher And Student)(Arabic)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.subSabaqTitleAudioArabic ===
                                    "string"
                                    ? elementInArray?.subSabaqTitleAudioArabic.substring(
                                      elementInArray?.subSabaqTitleAudioArabic
                                        .length - 15,
                                      elementInArray?.subSabaqTitleAudioArabic
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.subSabaqTitle }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      subSabaqTitle: "100%",
                                    });
                                    setAddNamaz({
                                      ...addNamaz,
                                      subSabaq: addNamaz.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              subSabaqTitleAudioArabic:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                          <div className="col-md-12 mb-3">
                            <Form.Label>Sub Sabaq Title Audio(Teacher And Student)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImage"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setAddNamaz({
                                  ...addNamaz,
                                  subSabaq: addNamaz.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          subSabaqTitleAudio:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                           <div className="col-md-12 mb-3">
                            <Form.Label>Sub Sabaq Title Audio(Teacher And Student)(English)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImage"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setAddNamaz({
                                  ...addNamaz,
                                  subSabaq: addNamaz.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          subSabaqTitleAudioEnglish:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                           <div className="col-md-12 mb-3">
                            <Form.Label>Sub Sabaq Title Audio(Teacher And Student)(Arabic)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImage"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setAddNamaz({
                                  ...addNamaz,
                                  subSabaq: addNamaz.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          subSabaqTitleAudioArabic:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                          </>
                        )}
                        {idEdit ? (
                          <>
                            <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Title Audio(Teacher)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.titleTeacherAudioPath ===
                                    "string"
                                    ? elementInArray?.titleTeacherAudioPath.substring(
                                      elementInArray?.titleTeacherAudioPath
                                        .length - 15,
                                      elementInArray?.titleTeacherAudioPath
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="titleTeacherAudioPath"
                                  style={{ width: imageWidth.subSabaqTitle }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      subSabaqTitle: "100%",
                                    });
                                    setAddNamaz({
                                      ...addNamaz,
                                      subSabaq: addNamaz.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              titleTeacherAudioPath:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                             <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Title Audio(Teacher)(English)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.subSabaqTitleTeacherAudioEnglish ===
                                    "string"
                                    ? elementInArray?.subSabaqTitleTeacherAudioEnglish.substring(
                                      elementInArray?.subSabaqTitleTeacherAudioEnglish
                                        .length - 15,
                                      elementInArray?.subSabaqTitleTeacherAudioEnglish
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="titleTeacherAudioPath"
                                  style={{ width: imageWidth.subSabaqTitle }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      subSabaqTitle: "100%",
                                    });
                                    setAddNamaz({
                                      ...addNamaz,
                                      subSabaq: addNamaz.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              subSabaqTitleTeacherAudioEnglish:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                             <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Title Audio(Teacher)(Arabic)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.subSabaqTitleTeacherAudioArabic ===
                                    "string"
                                    ? elementInArray?.subSabaqTitleTeacherAudioArabic.substring(
                                      elementInArray?.subSabaqTitleTeacherAudioArabic
                                        .length - 15,
                                      elementInArray?.subSabaqTitleTeacherAudioArabic
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="titleTeacherAudioPath"
                                  style={{ width: imageWidth.subSabaqTitle }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      subSabaqTitle: "100%",
                                    });
                                    setAddNamaz({
                                      ...addNamaz,
                                      subSabaq: addNamaz.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              subSabaqTitleTeacherAudioArabic:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                          <div className="col-md-12 mb-3">
                            <Form.Label>Sub Sabaq Title Audio(Teacher)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="titleTeacherAudioPath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setAddNamaz({
                                  ...addNamaz,
                                  subSabaq: addNamaz.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          titleTeacherAudioPath:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                            <div className="col-md-12 mb-3">
                            <Form.Label>Sub Sabaq Title Audio(Teacher)(English)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="titleTeacherAudioPath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setAddNamaz({
                                  ...addNamaz,
                                  subSabaq: addNamaz.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          subSabaqTitleTeacherAudioEnglish:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                            <div className="col-md-12 mb-3">
                            <Form.Label>Sub Sabaq Title Audio(Teacher)(Arabic)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="titleTeacherAudioPath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setAddNamaz({
                                  ...addNamaz,
                                  subSabaq: addNamaz.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          subSabaqTitleTeacherAudioArabic:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                          </>
                        )}
                        <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Reference</Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqDescReference}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescReference: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Reference
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Reference(English)</Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqDescReferenceEnglsih}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescReferenceEnglsih: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Reference
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Reference(Hindi)</Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqDescReferenceHindi}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescReferenceHindi: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Reference
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Reference(Urdu)</Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqDescReferenceUrdu}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescReferenceUrdu: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Reference
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Reference(Arabic)</Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqDescReferenceArabic}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescReferenceArabic: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Reference
                          </Form.Control.Feedback>
                        </div>

                        <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Description</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={elementInArray?.subSabaqDesc}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDesc: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Aqaaid Description.
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Description(English)</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={elementInArray?.subSabaqDescEnglish}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescEnglish: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Aqaaid Description.
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Description(Hindi)</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={elementInArray?.subSabaqDescHindi}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescHindi: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Aqaaid Description.
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Description(Urdu)</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={elementInArray?.subSabaqDescUrdu}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescUrdu: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Aqaaid Description.
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Description(Arabic)</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={elementInArray?.subSabaqDescArabic}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescArabic: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Aqaaid Description.
                          </Form.Control.Feedback>
                        </div>

                        <>
                          {idEdit ? (
                            <>
                              <div className="row d-flex">
                                <div className="col-md-12">
                                  <label htmlFor="" className="key">
                                    Sub Sabaq Description Audio(Teacher And Student)
                                  </label>
                                </div>
                                <div
                                  className={
                                    imageWidth === "100%"
                                      ? "d-none"
                                      : "col-md-6 "
                                  }
                                >
                                  <Form.Label>
                                    {typeof elementInArray?.subSabaqDescAudio ===
                                      "string"
                                      ? elementInArray?.subSabaqDescAudio.substring(
                                        elementInArray?.subSabaqDescAudio
                                          .length - 15,
                                        elementInArray?.subSabaqDescAudio
                                          .length
                                      )
                                      : ""}
                                  </Form.Label>
                                </div>
                                <div className="col-md-12 mb-3 ">
                                  <Form.Control
                                    type="file"
                                    accept="audio/mp3,audio/*;capture=microphone"
                                    name="sabaqImage"
                                    style={{ width: imageWidth.Description }}
                                    onChange={(e) => {
                                      setImageWidth({
                                        ...imageWidth,
                                        Description: "100%",
                                      });
                                      setAddNamaz({
                                        ...addNamaz,
                                        subSabaq: addNamaz.subSabaq.map(
                                          (item, innerIndex) => {
                                            return index === innerIndex
                                              ? {
                                                ...item,
                                                subSabaqDescAudio:
                                                  e.target.files[0],
                                              }
                                              : item;
                                          }
                                        ),
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Please Enter Sabaq Name
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                               <div className="row d-flex">
                                <div className="col-md-12">
                                  <label htmlFor="" className="key">
                                    Sub Sabaq Description Audio(Teacher And Student)(English)
                                  </label>
                                </div>
                                <div
                                  className={
                                    imageWidth === "100%"
                                      ? "d-none"
                                      : "col-md-6 "
                                  }
                                >
                                  <Form.Label>
                                    {typeof elementInArray?.subSabaqDescAudioEnglish ===
                                      "string"
                                      ? elementInArray?.subSabaqDescAudioEnglish.substring(
                                        elementInArray?.subSabaqDescAudioEnglish
                                          .length - 15,
                                        elementInArray?.subSabaqDescAudioEnglish
                                          .length
                                      )
                                      : ""}
                                  </Form.Label>
                                </div>
                                <div className="col-md-12 mb-3 ">
                                  <Form.Control
                                    type="file"
                                    accept="audio/mp3,audio/*;capture=microphone"
                                    name="sabaqImage"
                                    style={{ width: imageWidth.Description }}
                                    onChange={(e) => {
                                      setImageWidth({
                                        ...imageWidth,
                                        Description: "100%",
                                      });
                                      setAddNamaz({
                                        ...addNamaz,
                                        subSabaq: addNamaz.subSabaq.map(
                                          (item, innerIndex) => {
                                            return index === innerIndex
                                              ? {
                                                ...item,
                                                subSabaqDescAudioEnglish:
                                                  e.target.files[0],
                                              }
                                              : item;
                                          }
                                        ),
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Please Enter Sabaq Name
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                               <div className="row d-flex">
                                <div className="col-md-12">
                                  <label htmlFor="" className="key">
                                    Sub Sabaq Description Audio(Teacher And Student)(Arabic)
                                  </label>
                                </div>
                                <div
                                  className={
                                    imageWidth === "100%"
                                      ? "d-none"
                                      : "col-md-6 "
                                  }
                                >
                                  <Form.Label>
                                    {typeof elementInArray?.subSabaqDescAudioArabic ===
                                      "string"
                                      ? elementInArray?.subSabaqDescAudioArabic.substring(
                                        elementInArray?.subSabaqDescAudioArabic
                                          .length - 15,
                                        elementInArray?.subSabaqDescAudioArabic
                                          .length
                                      )
                                      : ""}
                                  </Form.Label>
                                </div>
                                <div className="col-md-12 mb-3 ">
                                  <Form.Control
                                    type="file"
                                    accept="audio/mp3,audio/*;capture=microphone"
                                    name="sabaqImage"
                                    style={{ width: imageWidth.Description }}
                                    onChange={(e) => {
                                      setImageWidth({
                                        ...imageWidth,
                                        Description: "100%",
                                      });
                                      setAddNamaz({
                                        ...addNamaz,
                                        subSabaq: addNamaz.subSabaq.map(
                                          (item, innerIndex) => {
                                            return index === innerIndex
                                              ? {
                                                ...item,
                                                subSabaqDescAudioArabic:
                                                  e.target.files[0],
                                              }
                                              : item;
                                          }
                                        ),
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Please Enter Sabaq Name
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                            </>
                          ) : (
                          <>
                            <div className="col-md-12 mb-3">
                              <Form.Label>
                                Sub Sabaq Description Audio(Teacher And Student)
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="audio/mp3,audio/*;capture=microphone"
                                name="sabaqImage"
                                //  / value={addSabaq?.sabaqAudio}
                                onChange={(e) => {
                                  setAddNamaz({
                                    ...addNamaz,
                                    subSabaq: addNamaz.subSabaq.map(
                                      (item, innerIndex) => {
                                        return index === innerIndex
                                          ? {
                                            ...item,
                                            subSabaqDescAudio:
                                              e.target.files[0],
                                          }
                                          : item;
                                      }
                                    ),
                                  });
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                Please Enter Sabaq Name
                              </Form.Control.Feedback>
                            </div>
                             <div className="col-md-12 mb-3">
                              <Form.Label>
                                Sub Sabaq Description Audio(Teacher And Student)(English)
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="audio/mp3,audio/*;capture=microphone"
                                name="sabaqImage"
                                //  / value={addSabaq?.sabaqAudio}
                                onChange={(e) => {
                                  setAddNamaz({
                                    ...addNamaz,
                                    subSabaq: addNamaz.subSabaq.map(
                                      (item, innerIndex) => {
                                        return index === innerIndex
                                          ? {
                                            ...item,
                                            subSabaqDescAudioEnglish:
                                              e.target.files[0],
                                          }
                                          : item;
                                      }
                                    ),
                                  });
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                Please Enter Sabaq Name
                              </Form.Control.Feedback>
                            </div>
                             <div className="col-md-12 mb-3">
                              <Form.Label>
                                Sub Sabaq Description Audio(Teacher And Student)(Arabic)
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="audio/mp3,audio/*;capture=microphone"
                                name="sabaqImage"
                                //  / value={addSabaq?.sabaqAudio}
                                onChange={(e) => {
                                  setAddNamaz({
                                    ...addNamaz,
                                    subSabaq: addNamaz.subSabaq.map(
                                      (item, innerIndex) => {
                                        return index === innerIndex
                                          ? {
                                            ...item,
                                            subSabaqDescAudioArabic:
                                              e.target.files[0],
                                          }
                                          : item;
                                      }
                                    ),
                                  });
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                Please Enter Sabaq Name
                              </Form.Control.Feedback>
                            </div>
                            </>
                          )}
                          {idEdit ? (
                            <>
                              <div className="row d-flex">
                                <div className="col-md-12">
                                  <label htmlFor="" className="key">
                                    Sub Sabaq Description Audio(Teacher)
                                  </label>
                                </div>
                                <div
                                  className={
                                    imageWidth === "100%"
                                      ? "d-none"
                                      : "col-md-6 "
                                  }
                                >
                                  <Form.Label>
                                    {typeof elementInArray?.teacherDescAudioPath ===
                                      "string"
                                      ? elementInArray?.teacherDescAudioPath.substring(
                                        elementInArray?.teacherDescAudioPath
                                          .length - 15,
                                        elementInArray?.teacherDescAudioPath
                                          .length
                                      )
                                      : ""}
                                  </Form.Label>
                                </div>
                                <div className="col-md-12 mb-3 ">
                                  <Form.Control
                                    type="file"
                                    accept="audio/mp3,audio/*;capture=microphone"
                                    name="teacherDescAudioPath"
                                    style={{ width: imageWidth.Description }}
                                    onChange={(e) => {
                                      setImageWidth({
                                        ...imageWidth,
                                        Description: "100%",
                                      });
                                      setAddNamaz({
                                        ...addNamaz,
                                        subSabaq: addNamaz.subSabaq.map(
                                          (item, innerIndex) => {
                                            return index === innerIndex
                                              ? {
                                                ...item,
                                                teacherDescAudioPath:
                                                  e.target.files[0],
                                              }
                                              : item;
                                          }
                                        ),
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Please Enter Sabaq Name
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                               <div className="row d-flex">
                                <div className="col-md-12">
                                  <label htmlFor="" className="key">
                                    Sub Sabaq Description Audio(Teacher)(English)
                                  </label>
                                </div>
                                <div
                                  className={
                                    imageWidth === "100%"
                                      ? "d-none"
                                      : "col-md-6 "
                                  }
                                >
                                  <Form.Label>
                                    {typeof elementInArray?.subSabaqDescTeacherAudioEnglish ===
                                      "string"
                                      ? elementInArray?.subSabaqDescTeacherAudioEnglish.substring(
                                        elementInArray?.subSabaqDescTeacherAudioEnglish
                                          .length - 15,
                                        elementInArray?.subSabaqDescTeacherAudioEnglish
                                          .length
                                      )
                                      : ""}
                                  </Form.Label>
                                </div>
                                <div className="col-md-12 mb-3 ">
                                  <Form.Control
                                    type="file"
                                    accept="audio/mp3,audio/*;capture=microphone"
                                    name="teacherDescAudioPath"
                                    style={{ width: imageWidth.Description }}
                                    onChange={(e) => {
                                      setImageWidth({
                                        ...imageWidth,
                                        Description: "100%",
                                      });
                                      setAddNamaz({
                                        ...addNamaz,
                                        subSabaq: addNamaz.subSabaq.map(
                                          (item, innerIndex) => {
                                            return index === innerIndex
                                              ? {
                                                ...item,
                                                subSabaqDescTeacherAudioEnglish:
                                                  e.target.files[0],
                                              }
                                              : item;
                                          }
                                        ),
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Please Enter Sabaq Name
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                               <div className="row d-flex">
                                <div className="col-md-12">
                                  <label htmlFor="" className="key">
                                    Sub Sabaq Description Audio(Teacher)(Arabic)
                                  </label>
                                </div>
                                <div
                                  className={
                                    imageWidth === "100%"
                                      ? "d-none"
                                      : "col-md-6 "
                                  }
                                >
                                  <Form.Label>
                                    {typeof elementInArray?.subSabaqDescTeacherAudioArabic ===
                                      "string"
                                      ? elementInArray?.subSabaqDescTeacherAudioArabic.substring(
                                        elementInArray?.subSabaqDescTeacherAudioArabic
                                          .length - 15,
                                        elementInArray?.subSabaqDescTeacherAudioArabic
                                          .length
                                      )
                                      : ""}
                                  </Form.Label>
                                </div>
                                <div className="col-md-12 mb-3 ">
                                  <Form.Control
                                    type="file"
                                    accept="audio/mp3,audio/*;capture=microphone"
                                    name="teacherDescAudioPath"
                                    style={{ width: imageWidth.Description }}
                                    onChange={(e) => {
                                      setImageWidth({
                                        ...imageWidth,
                                        Description: "100%",
                                      });
                                      setAddNamaz({
                                        ...addNamaz,
                                        subSabaq: addNamaz.subSabaq.map(
                                          (item, innerIndex) => {
                                            return index === innerIndex
                                              ? {
                                                ...item,
                                                subSabaqDescTeacherAudioArabic:
                                                  e.target.files[0],
                                              }
                                              : item;
                                          }
                                        ),
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Please Enter Sabaq Name
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                            <div className="col-md-12 mb-3">
                              <Form.Label>
                                Sub Sabaq Description Audio(Teacher)
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="audio/mp3,audio/*;capture=microphone"
                                name="sabaqImage"
                                //  / value={addSabaq?.sabaqAudio}
                                onChange={(e) => {
                                  setAddNamaz({
                                    ...addNamaz,
                                    subSabaq: addNamaz.subSabaq.map(
                                      (item, innerIndex) => {
                                        return index === innerIndex
                                          ? {
                                            ...item,
                                            teacherDescAudioPath:
                                              e.target.files[0],
                                          }
                                          : item;
                                      }
                                    ),
                                  });
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                Please Enter Sabaq Name
                              </Form.Control.Feedback>
                            </div>
                               <div className="col-md-12 mb-3">
                              <Form.Label>
                                Sub Sabaq Description Audio(Teacher)(English)
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="audio/mp3,audio/*;capture=microphone"
                                name="sabaqImage"
                                //  / value={addSabaq?.sabaqAudio}
                                onChange={(e) => {
                                  setAddNamaz({
                                    ...addNamaz,
                                    subSabaq: addNamaz.subSabaq.map(
                                      (item, innerIndex) => {
                                        return index === innerIndex
                                          ? {
                                            ...item,
                                            subSabaqDescTeacherAudioEnglish:
                                              e.target.files[0],
                                          }
                                          : item;
                                      }
                                    ),
                                  });
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                Please Enter Sabaq Name
                              </Form.Control.Feedback>
                            </div>
                               <div className="col-md-12 mb-3">
                              <Form.Label>
                                Sub Sabaq Description Audio(Teacher)(Arabic)
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="audio/mp3,audio/*;capture=microphone"
                                name="sabaqImage"
                                //  / value={addSabaq?.sabaqAudio}
                                onChange={(e) => {
                                  setAddNamaz({
                                    ...addNamaz,
                                    subSabaq: addNamaz.subSabaq.map(
                                      (item, innerIndex) => {
                                        return index === innerIndex
                                          ? {
                                            ...item,
                                            subSabaqDescTeacherAudioArabic:
                                              e.target.files[0],
                                          }
                                          : item;
                                      }
                                    ),
                                  });
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                Please Enter Sabaq Name
                              </Form.Control.Feedback>
                            </div>
                            </>
                          )}
                        </>
                      </div>
                      <div className="text-end">
                        <Link
                          to="#"
                          className={
                            addNamaz.subSabaq.length > 1
                              ? "btn btn-danger"
                              : "btn btn-secondary invisible"
                          }
                          onClick={() => {
                            if (addNamaz.subSabaq.length > 1) {
                              const copySubDeatails = [...addNamaz.subSabaq];
                              copySubDeatails.splice(index, 1);
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: copySubDeatails,
                              });
                            }
                          }}
                        >
                          Remove
                        </Link>
                      </div>
                    </div>
                  );
                })}

              <Link
                to="#"
                className={"add-newSabaq-btn btn btn-primary"}
                onClick={() => {
                  let namaz = [
                    ...addNamaz.subSabaq,

                    {
                      subSabaqTitle: "",
                      subSabaqTitleEnglish:"",
                      subSabaqTitleHindi:"",
                      subSabaqTitleUrdu:"",
                      subSabaqTitleArabic:"",
                      subSabaqTitleAudio: "",
                      subSabaqTitleAudioEnglish:"",
                      subSabaqTitleAudioArabic:"",
                      subSabaqDesc: "",
                      subSabaqDescEnglish: "",
                      subSabaqDescHindi: "",
                      subSabaqDescUrdu: "",
                      subSabaqDescArabic: "",
 


                      subSabaqDescAudio: "",
                      subSabaqDescAudioEnglish:"",
                      subSabaqDescAudioArabic:"",
                      sabaqDescReference: "",
                      sabaqDescReferenceEnglish: "",
                      sabaqDescReferenceHindi: "",
                      sabaqDescReferenceUrdu: "",
                      sabaqDescReferenceArabic: "",
                      teacherDescAudioPath: "",
                      subSabaqDescTeacherAudioEnglish:"",
                      subSabaqDescTeacherAudioArabic:"",
                      titleTeacherAudioPath: '',
                      subSabaqTitleTeacherAudioEnglish:'',
                      subSabaqTitleTeacherAudioArabic:'',
                    },
                  ];
                  setAddNamaz({
                    ...addNamaz,
                    subSabaq: namaz,
                  });
                }}
              >
                + Add Sub Sabaq Details
              </Link>
            </div>
            <div className="buttons-modal border-top pt-3 text-end ">
              <button className="me-2" type="submit" disabled={saveBotton}>
                {idEdit === "edit" ? "update" : "Save"}
              </button>
              <Link
                to="#"
                className=" bg-danger"
                onClick={() => {
                  setAddNamaz({
                    sabaqName: "",
                    sabaqEnglish:"",
                    sabaqHindi:"",
                    sabaqUrdu:"",
                    sabaqArabic:"",
                    sabaqDesc: "",
                    sabaqDescEnglish:"",
                    sabaqDescHindi:"",
                    sabaqDescUrdu:"",
                    sabaqDescArabic:"",
                    sabaqDescAudio: "",
                    sabaqDescAudioEnglish:"",
                    sabaqDescAudioArabic:"",
                    sabaqNameAudio: "",
                    sabaqNameAudioEnglish:"",
                    sabaqNameAudioArabic:"",


                    sabaqDescReference: "",
                    sabaqDescReferenceEnglish: "",
                    sabaqDescReferenceHindi: "",
                    sabaqDescReferenceUrdu: "",
                    sabaqDescReferenceArabic: "",
                    



                    subSabaq: [
                      {
                        subSabaqTitle: "",
                        subSabaqTitleEnglish:"",
                        subSabaqTitleHindi:"",
                        subSabaqTitleUrdu:"",
                        subSabaqTitleArabic:"",
                        subSabaqTitleAudio: "",
                        subSabaqTitleAudioEnglish:"",
                        subSabaqTitleAudioArabic:"",
                        subSabaqDesc: "",
                        subSabaqDescEnglish: "",
                        subSabaqDescHindi: "",
                        subSabaqDescUrdu: "",
                        subSabaqDescArabic: "",
                        subSabaqDescAudio: "",
                        subSabaqDescAudioEnglish:"",
                        subSabaqDescAudioArabic:"",
                        subSabaqDescReference: "",
                        subSabaqDescReferenceEnglsih:"",
                        subSabaqDescReferenceHindi:"",
                        subSabaqDescReferenceUrdu:"",
                        subSabaqDescReferenceArabic:"",
                      },
                    ],
                  });
                  handleAddClose();
                  setIdEdit("");
                }}
              >
                Cancel
              </Link>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/* ======================= END ADD ========================== */}

      {/* ======================= DELETE ========================== */}

      <Modal
        show={deleteModal}
        onHide={handleDeleteClose}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-msg text-center">
            <label htmlFor="">Are you sure you want to delete this item?</label>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <div className="buttons-modal    ">
            <button
              className="me-2 bg-danger"
              type="submit"
              onClick={() => {
                handleDeleteClose();
                MasaiLisDeleteApi();
              }}
            >
              Delete
            </button>
            <Link to="#" className="" onClick={handleDeleteClose}>
              Cancel
            </Link>
          </div>
        </Modal.Footer>
      </Modal>
      {/* ======================= END DELETE ========================== */}

      {/* ======================= VIEW ========================== */}
      <Modal
        show={viewModal}
        onHide={handleViewClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Masaail Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="row">
              <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq No.
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.SabaqNo}
                  </label>
                </div>
              </div>

              {/* sabaqicon */}
              <div className="col-md-6 mb-3">
                {/* <div>
                    <label htmlFor="" className="key">
                      Sabaq Icon
                    </label>
                  </div>
                  <div>
                    <MDBRow>
                      <MDBCol lg="2" md="3" className="mb-4">
                        <img
                          src={
                            !viewDetails?.sabaqIcon
                              ? ""
                              : ApiConfig.FILE_BASE_URL +
                                viewDetails?.sabaqIcon.length
                              ? ApiConfig.FILE_BASE_URL + viewDetails?.sabaqIcon
                              : ApiConfig.FILE_BASE_URL +
                                  viewDetails?.sabaqIcon &&
                                URL.createObjectURL(
                                  ApiConfig.FILE_BASE_URL +
                                    viewDetails?.sabaqIcon
                                )
                          }
                          className="img-fluid rounded value"
                          alt=""
                        />
                      </MDBCol>
                    </MDBRow>
                  </div> */}
              </div>
              <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Name
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqName}
                  </label>
                </div>
              </div>
               <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Name(English)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqEnglish}
                  </label>
                </div>
              </div>
               <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Name(Hindi)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqHindi}
                  </label>
                </div>
              </div>
               <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Name(Urdu)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqUrdu}
                  </label>
                </div>
              </div>
               <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Name(Arabic)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqArabic}
                  </label>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio(Teacher And Student)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqAudio ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqAudio}`}
                        type="audio/ogg"
                      />
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqAudio}`}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio>
                  ) : (
                    ""
                  )}

                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio(Teacher And Student)(English)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqNameAudioEnglish ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqNameAudioEnglish}`}
                        type="audio/ogg"
                      />
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqNameAudioEnglish}`}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio>
                  ) : (
                    ""
                  )}

                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio(Teacher And Student)(Arabic)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqNameAudioArabic ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqNameAudioArabic}`}
                        type="audio/ogg"
                      />
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqNameAudioArabic}`}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio>
                  ) : (
                    ""
                  )}

                </div>
              </div>
              <div className="col-md-6 mb-3"></div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio(Teacher)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqTeacherAudio ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqTeacherAudio}`}
                        type="audio/ogg"
                      />
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqTeacherAudio}`}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio>
                  ) : (
                    ""
                  )}

                </div>
              </div>
                <div className="col-md-6 mb-3"></div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio(Teacher)(English)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqNameTeacherAudioEnglish ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqNameTeacherAudioEnglish}`}
                        type="audio/ogg"
                      />
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqNameTeacherAudioEnglish}`}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio>
                  ) : (
                    ""
                  )}

                </div>
              </div>
                <div className="col-md-6 mb-3"></div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio(Teacher)(Arabic)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqNameTeacherAudioArabic ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqNameTeacherAudioArabic}`}
                        type="audio/ogg"
                      />
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqNameTeacherAudioArabic}`}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio>
                  ) : (
                    ""
                  )}

                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Description
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDesc}
                  </label>
                </div>
              </div>
               <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Description(English)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescEnglish}
                  </label>
                </div>
              </div>
               <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Description(Hindi)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescHindi}
                  </label>
                </div>
              </div>
               <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Description(Urdu)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescUrdu}
                  </label>
                </div>
              </div>
               <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Description(Arabic)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescArabic}
                  </label>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Description Audio(Teacher And Student)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqDescAudio ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqDescAudio}`}
                        type="audio/ogg"
                      />
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqDescAudio}`}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio>
                  ) : ("")}

                </div>
              </div>
               <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Description Audio(Teacher And Student)(English)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqDescAudioEnglish ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqDescAudioEnglish}`}
                        type="audio/ogg"
                      />
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqDescAudioEnglish}`}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio>
                  ) : ("")}

                </div>
              </div>
               <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Description Audio(Teacher And Student)(Arabic)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqDescAudioArabic ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqDescAudioArabic}`}
                        type="audio/ogg"
                      />
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqDescAudioArabic}`}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio>
                  ) : ("")}

                </div>
              </div>

              <div className="col-md-6 mb-3"></div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Description Audio(Teacher)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqTeacherDesc ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqTeacherDesc}`}
                        type="audio/ogg"
                      />
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqTeacherDesc}`}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio>
                  ) : ("")}

                </div>
              </div>
                <div className="col-md-6 mb-3"></div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Description Audio(Teacher)(English)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqDescTeacherAudioEnglish ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqDescTeacherAudioEnglish}`}
                        type="audio/ogg"
                      />
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqDescTeacherAudioEnglish}`}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio>
                  ) : ("")}

                </div>
              </div>
                <div className="col-md-6 mb-3"></div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Description Audio(Teacher)(Arabic)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqDescTeacherAudioArabic ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqDescTeacherAudioArabic}`}
                        type="audio/ogg"
                      />
                      <source
                        src={`${FILE_BASE_URL}${viewDetails?.sabaqDescTeacherAudioArabic}`}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio>
                  ) : ("")}

                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Reference
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescReference}
                  </label>
                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Reference(English)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescReferenceEnglish}
                  </label>
                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Reference(Hindi)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescReferenceHindi}
                  </label>
                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Reference(Urdu)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescReferenceUrdu}
                  </label>
                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Reference(Arabic)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescReferenceArabic}
                  </label>
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Image
                  </label>
                </div>
                <div>
                  <MDBRow>
                    <MDBCol lg="2" md="1" className="mb-4">
                      <img
                        src={
                          !viewDetails?.sabaqImage
                            ? ""
                            : ApiConfig.FILE_BASE_URL + viewDetails?.sabaqImage.length
                              ? ApiConfig.FILE_BASE_URL + viewDetails?.sabaqImage
                              : ApiConfig.FILE_BASE_URL + viewDetails?.sabaqImage &&
                              URL.createObjectURL(ApiConfig.FILE_BASE_URL + viewDetails?.sabaqImage)
                        }
                        className="img-fluid rounded"
                        alt=""
                      />
                    </MDBCol>
                  </MDBRow>
                </div>
              </div>

              <h5 className="fw-bold">Sub Sabaq Details</h5>
              {viewDetails.subSabaqs &&
                viewDetails.subSabaqs.length > 0 &&
                viewDetails.subSabaqs.map((ele, index) => {
                  return (
                    <div className="sub-group-main row">
                      <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Title {index + 1}
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqTitle}
                          </label>
                        </div>
                      </div>
                        <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Title(English) {index + 1}
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqTitleEnglish}
                          </label>
                        </div>
                      </div>
                        <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Title(Hindi) {index + 1}
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqTitleHindi}
                          </label>
                        </div>
                      </div>
                        <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Title(Urdu) {index + 1}
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqTitleUrdu}
                          </label>
                        </div>
                      </div>
                        <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Title(Arabic) {index + 1}
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqTitleArabic}
                          </label>
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Title Audio(Teacher And Student)
                          </label>
                        </div>
                        <div>
                          {ele?.titleAudioPath ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source
                                src={`${FILE_BASE_URL}${ele.titleAudioPath}`}
                                type="audio/ogg"
                              />
                              <source
                                src={`${FILE_BASE_URL}${ele.titleAudioPath}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : ('')}

                        </div>
                      </div>
                        <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Title Audio(Teacher And Student)(English)
                          </label>
                        </div>
                        <div>
                          {ele?.subSabaqTitleAudioEnglish ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source
                                src={`${FILE_BASE_URL}${ele.subSabaqTitleAudioEnglish}`}
                                type="audio/ogg"
                              />
                              <source
                                src={`${FILE_BASE_URL}${ele.subSabaqTitleAudioEnglish}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : ('')}

                        </div>
                      </div>
                        <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Title Audio(Teacher And Student)(Arabic)
                          </label>
                        </div>
                        <div>
                          {ele?.subSabaqTitleAudioArabic ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source
                                src={`${FILE_BASE_URL}${ele.subSabaqTitleAudioArabic}`}
                                type="audio/ogg"
                              />
                              <source
                                src={`${FILE_BASE_URL}${ele.subSabaqTitleAudioArabic}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : ('')}

                        </div>
                      </div>
                      <div className="col-md-6 mb-3"></div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Title Audio(Teacher )
                          </label>
                        </div>
                        <div>
                          {ele?.titleTeacherAudioPath ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source
                                src={`${FILE_BASE_URL}${ele.titleTeacherAudioPath}`}
                                type="audio/ogg"
                              />
                              <source
                                src={`${FILE_BASE_URL}${ele.titleTeacherAudioPath}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : ('')}

                        </div>
                      </div>
                       <div className="col-md-6 mb-3"></div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Title Audio(Teacher)(English)
                          </label>
                        </div>
                        <div>
                          {ele?.subSabaqTitleTeacherAudioEnglish ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source
                                src={`${FILE_BASE_URL}${ele.subSabaqTitleTeacherAudioEnglish}`}
                                type="audio/ogg"
                              />
                              <source
                                src={`${FILE_BASE_URL}${ele.subSabaqTitleTeacherAudioEnglish}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : ('')}

                        </div>
                      </div>
                       <div className="col-md-6 mb-3"></div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Title Audio(Teacher)(Arabic)
                          </label>
                        </div>
                        <div>
                          {ele?.subSabaqTitleTeacherAudioArabic ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source
                                src={`${FILE_BASE_URL}${ele.subSabaqTitleTeacherAudioArabic}`}
                                type="audio/ogg"
                              />
                              <source
                                src={`${FILE_BASE_URL}${ele.subSabaqTitleTeacherAudioArabic}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : ('')}

                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Description
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqDesc}
                          </label>
                        </div>
                      </div>
                       <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Description(English)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqDescEnglish}
                          </label>
                        </div>
                      </div>
                       <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Description(Hindi)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqDescHindi}
                          </label>
                        </div>
                      </div>
                       <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Description(Urdu)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqDescUrdu}
                          </label>
                        </div>
                      </div>
                       <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Description(Arabic)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqDescArabic}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Description Audio(Teacher And Student)
                          </label>
                        </div>
                        <div>
                          {ele?.descAudioPath ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source
                                src={`${FILE_BASE_URL}${ele.descAudioPath}`}
                                type="audio/ogg"
                              />
                              <source
                                src={`${FILE_BASE_URL}${ele.descAudioPath}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : ("")}

                        </div>
                      </div>
                       <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Description Audio(Teacher And Student)(English)
                          </label>
                        </div>
                        <div>
                          {ele?.subSabaqDescAudioEnglish ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source
                                src={`${FILE_BASE_URL}${ele.subSabaqDescAudioEnglish}`}
                                type="audio/ogg"
                              />
                              <source
                                src={`${FILE_BASE_URL}${ele.subSabaqDescAudioEnglish}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : ("")}

                        </div>
                      </div>
                       <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Description Audio(Teacher And Student)(Arabic)
                          </label>
                        </div>
                        <div>
                          {ele?.subSabaqDescAudioArabic ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source
                                src={`${FILE_BASE_URL}${ele.subSabaqDescAudioArabic}`}
                                type="audio/ogg"
                              />
                              <source
                                src={`${FILE_BASE_URL}${ele.subSabaqDescAudioArabic}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : ("")}

                        </div>
                      </div>
                      <div className="col-md-6 mb-3"></div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Description Audio(Teacher )
                          </label>
                        </div>
                        <div>
                          {ele?.teacherDescAudioPath ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source
                                src={`${FILE_BASE_URL}${ele.teacherDescAudioPath}`}
                                type="audio/ogg"
                              />
                              <source
                                src={`${FILE_BASE_URL}${ele.teacherDescAudioPath}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : ("")}

                        </div>
                      </div>
                      <div className="col-md-12 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Reference
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqDescReference}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-12 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Reference(English)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqDescReferenceEnglsih}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-12 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Reference(Hindi)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqDescReferenceHindi}
                          </label>
                        </div>
                      </div>
                        <div className="col-md-12 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Reference(Urdu)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqDescReferenceUrdu}
                          </label>
                        </div>
                      </div>
                       <div className="col-md-12 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Reference(Arabic)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqDescReferenceArabic}
                          </label>
                        </div>
                      </div>

                    </div>
                  );
                })}
            </div>
            <div className="buttons-modal border-top pt-3 text-end ">
              <Link to="#" className="bg-danger" onClick={handleViewClose}>
                Cancel
              </Link>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/* ======================= END VIEW ========================== */}
      {loader ? (
        <FormLoader />
      ) : (
        <div className="table-wrapper">
          <h6>Total Records : {masaiList.length}</h6>
          <Table className="display" striped bordered hover size="lg">
            <thead className="text-center">
              <tr>
                <th>Sabaq No.</th>
                <th
                // style={{ textAlign: "left" }}
                >Sabaq List</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {masaiList && masaiList.length > 0
                ? masaiList.slice(startIndex, endIndex).map((ele, index) => {
                  return (
                    <tr>
                      <td>{index + 1 + startIndex}</td>

                      <td style={{ textAlign: "left" }}>{ele.sabaqName}</td>
                      <td className="action">
                        <Link
                          to="#"
                          className="icon edit"
                          onClick={() => {
                            // handleAddShow();
                            setIdEdit("edit");
                            setImageWidth({
                              ...imageWidth,
                              sabaqAudio: "117px",
                              Uploade: "117px",
                              Tarjama: "117px",
                              Description: "117px",
                              subSabaqTitle: "117px",
                            });
                            EditListApi(ele.sabaqId);
                          }}
                        >
                          <img src={ic_edit} alt="" />
                        </Link>
                        <Link
                          to="#"
                          className="icon view"
                          onClick={() => viewDetailshandle(ele.sabaqId)}
                        >
                          <img src={ic_eyes} alt="" />
                        </Link>
                        <Link
                          to="#"
                          className="icon delete"
                          onClick={() => {
                            handleDeleteShow();
                            setDeleteId(ele.sabaqId);
                          }}
                        >
                          <img src={ic_delete} alt="" />
                        </Link>
                      </td>
                    </tr>
                  );
                })
                : ""}
            </tbody>
          </Table>
          {masaiList && masaiList.length > 0 ? (
            <Pagination
              changePage={changePage}
              pageCount={pageCount}
              currentPage={currentPage}
            />
          ) : (
            <div>
              <h5 style={{ color: "red", textAlign: "center" }}>
                {" "}
                Records Not Found
              </h5>
            </div>
          )}
        </div>
      )}
    </main>
  );
};

export default Masaail;
